export default __webpack_public_path__ + "media/assets/images/apple_store-137242d3bfc20cefa557598d92b9c3f1.png";